import { createAsyncThunk } from "@reduxjs/toolkit";
import { axios } from "services/axios";

  /* -------------------------------------------- Get CostAdjustment Reports List ------------------------------------ */
  export const getInventoryLevelsReportList = createAsyncThunk("inventoryLevelsReport/getInventoryLevelsReportList",  
    async (args, thunkApi) => {
    try {
      const { data } = await axios.get(`https://rostoapi.smartgate-egypt.com/Reports/GetInventoryLevelsList`);
      return thunkApi.fulfillWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e.response.data);
    }
  }
);


 /* --------------------------------------- Inventory Levels Filter Data ------------------------------*/
 export const getInventoryLevelsFilteredData = createAsyncThunk("inventoryLevelsReport/getInventoryLevelsFilteredData ", 
  async (args, thunkApi) => {
  try {
    return (args);
  } catch (e) {
    return thunkApi.rejectWithValue(e.response.data);
  }
}
);
export const resetInventoryLevelsFilteredData = createAsyncThunk( "inventoryLevelsReport/resetInventoryLevelsFilteredData ", 
  async (args, thunkApi) => { 
  try {
    return args;
  } catch (e) {
    return thunkApi.rejectWithValue(e.response.data);
  }
}
);